import React from "react";
import { Layout } from "src/components/layout/Layout";
import { ModuleRouter } from "src/components/molecules";
import { SchedulingRoute } from "./scheduling.routes";

type Props = {};

export function SchedulingModule({}: Props): React.ReactElement {
  return (
    <Layout>
      {SchedulingRoute.subRoutes && (
        <ModuleRouter subRoutes={SchedulingRoute.subRoutes} path={SchedulingRoute.path} />
      )}
    </Layout>
  );
}
